import request from '@/utils/request'
// 满意度调查详情页面提交
export function addServerSurvey(object) {
    const data = object;
    return request({
        url: "/addServerSurvey",
        method: "post",
        data
    })
}
// 判断是否已提交满意度
export function isExistServerSurvey() {
    return request({
        url: "/isExistServerSurvey",
        method: "get"
    })
}


// WEBPACK FOOTER //
// ./src/api/diagnoses.js